import { render } from "./CookiesNumberInput.vue?vue&type=template&id=12f737a1&scoped=true"
import script from "./CookiesNumberInput.vue?vue&type=script&lang=js"
export * from "./CookiesNumberInput.vue?vue&type=script&lang=js"

import "./CookiesNumberInput.vue?vue&type=style&index=0&id=12f737a1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f737a1"]])

export default __exports__